import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const VolumeSliderContainer = styled.div`
  width: 100%;
`

export const VolumeSliderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
`

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const ValueChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 4px;
  border-radius: 4px;
  background: ${COLORS.primaryExtraLight};
  color: ${COLORS.secondaryDark};
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
`
